import { ChangeEvent, useRef, useState } from 'react'

import { TextField } from '@joor/design-system'
import styled from 'styled-components'

import { OrphanRetailer } from '__generated__/atlas-types'

import { BrandStartOrderIds } from 'modals/OrderList/StartOrderModal/StartOrderModal.ids'

import messages from '../../BrandStartOrderModal.messages'

const INPUT_MAX_LENGTH = 150
const EMAIL_VALIDATION_REGEX = new RegExp(
  [
    "^((?!.*\\.{2})[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-]",
    "(?:[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~.-]{0,62}[a-zA-Z0-9!#$%&'*+\\/=?^_`{|}~-])?",
    '|"[^"]{1,62}")@([a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\\.)+',
    '[a-zA-Z0-9]{2,63}$',
  ].join(''),
)

interface CustomerEmailProps {
  orphanRetailer: OrphanRetailer
  setOrphanRetailer: (data: OrphanRetailer | null) => void
}

export const CustomerEmail = ({
  orphanRetailer,
  setOrphanRetailer,
}: CustomerEmailProps) => {
  const [email, setEmail] = useState('')
  const [hasLeftInput, setHasLeftInput] = useState(false)
  const { id, retailerEmail } = orphanRetailer
  const validateTimeout = useRef<NodeJS.Timeout | null>(null)

  const handleEmailChange = (event: ChangeEvent<HTMLInputElement>) => {
    const email = event.target.value
    setEmail(email)
    if (validateTimeout.current) {
      clearTimeout(validateTimeout.current)
    }
    validateTimeout.current = setTimeout(() => {
      // TODO: add mutation to validate email and error message if invalid
      if (EMAIL_VALIDATION_REGEX.test(email)) {
        setOrphanRetailer({
          ...orphanRetailer,
          retailerEmail: email,
        })
      } else {
        setOrphanRetailer({
          ...orphanRetailer,
          retailerEmail: '',
        })
      }
    }, 500)
  }

  return (
    <NewCustomerEmailInput>
      <TextField
        id={BrandStartOrderIds.NewCustomerEmailInput}
        label={messages.buyerEmail}
        placeholder={messages.enterBuyerEmail}
        value={id ? retailerEmail : email}
        maxLength={INPUT_MAX_LENGTH}
        type="alphanumeric"
        onChange={handleEmailChange}
        isRequired
        disabled={!!id}
        onBlur={() => setHasLeftInput(true)}
        onFocus={() => setHasLeftInput(false)}
        errorMessage={
          !retailerEmail && hasLeftInput ? messages.invalidEmail : ''
        }
      />
    </NewCustomerEmailInput>
  )
}

const NewCustomerEmailInput = styled.div`
  max-width: 440px;
  margin-bottom: 14px;

  input {
    font-size: var(--size-font-small) !important;
  }
`
